// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sid-response-item-type-tag{display:inline-flex;align-items:center;border-radius:24px}", ""]);
// Exports
module.exports = exports;
